/**
 * Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 * All information herein, source code below as well as the Morpheus system itself and all related
 * software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 * Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 * is prohibited.
 */

import { replaceSubdomain } from '@morpheus/utils/admin-vue/helpers/api-helper'
import axios from 'axios'
import { AdminCreateData, AdminListData, AdminListItemData, AdminShowData } from '../types'

const adminBaseURL = replaceSubdomain(process.env.VUE_APP_API_SUBDOMAIN_ADMIN)

export const adminClient = axios.create({
  baseURL: adminBaseURL
})

export const adminRoleList = ['admin'] // fixme! hardcoded list; it is better to get this data from anywhere

export function fetchAdminList (param: string): Promise<AdminListData> {
  param = param || ''
  return new Promise((resolve, reject) => {
    adminClient.get(`${param}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function fetchAdminById (id: string): Promise<AdminShowData> {
  return new Promise((resolve, reject) => {
    adminClient.get(`${id}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function createAdmin (admin: AdminCreateData): Promise<AdminListItemData> {
  return new Promise((resolve, reject) => {
    adminClient.post('', admin)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function updateAdmin (admin: AdminCreateData, id: string): Promise<AdminListItemData> {
  return new Promise((resolve, reject) => {
    adminClient.put(`${id}`, admin)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function deleteAdminById (id: string): Promise<AdminShowData> {
  return new Promise((resolve, reject) => {
    adminClient.delete(`${id}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function searchAdmin (q:string): Promise<AdminListData> {
  return new Promise((resolve, reject) => {
    adminClient.get(`/search?query=${q}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export default {
  fetchAdminList,
  fetchAdminById,
  createAdmin,
  updateAdmin,
  deleteAdminById,
  searchAdmin
}
